import { cpfCompleteMask } from 'app/masks'
import React, { useContext, useState, createContext } from 'react'
import { finishLoading, startLoading } from 'store/helpers'
import FuncionarioService from 'services/funcionario'

const VisibilityContext = createContext({})

export function VisibilityProvider({ children }) {
  const [showCpf, setShowCpf] = useState(false)

  const [cpf, setCpf] = useState('***********')

  async function handleShowCpf(idFuncionario) {
    if (!showCpf) {
      startLoading()
      const { ok, data } = await FuncionarioService.findDadosComplementaresById(idFuncionario)
      finishLoading()
      if (!ok) {
        return setShowCpf(false)
      }
      setCpf(data.cpf)
    }
    setShowCpf(!showCpf)
  }

  function hideContent(value) {
    if (value) {
      return cpfCompleteMask(value)
    }
  }

  return (
    <VisibilityContext.Provider value={{ setShowCpf, showCpf, hideContent, handleShowCpf, cpf }}>
      {children}
    </VisibilityContext.Provider>
  )
}

export function useVisibility() {
  return useContext(VisibilityContext)
}
